import { Component } from '@angular/core';

@Component({
  selector: 'app-matoptwad',
  template: `
    <iframe
      src="https://forms.office.com/Pages/ResponsePage.aspx?id=k6zvgJqLaE2538e1MQUsrRMw4VGcKVtNtWIsUOBrJihUNjJFVVlVSDNNN1VGM0NDNURPUjg4UldIOC4u"
      width="100%"
      height="100%"
      style="border: none;">
    </iframe>
  `,
  styles: [`
    iframe {
      width: 100%;
      height: 100vh;
      border: none;
    }
  `]
})
export class MatoptwadComponent { }
